import React, { useState, useEffect } from 'react';
import TextInput from '../../layout/forms/TextInput';

const CustomerTag = ({ state, setState }) => {   
    const onChange = (event) => {
        setState({
            ...state,
            customerTag: event.target.value
        })
    }
    return (
        <TextInput
            label="Customer tag"
            onChange={onChange}
            value={state.customerTag}           
        />        
    )
}
export default CustomerTag